import { dataProvider } from './KidsPlan.enums';
import { getLocale } from 'utils/date';
import i18n from 'config/i18n';

const t = i18n.getFixedT(getLocale(), 'common');
const prefixdataProviderOptions =
  'adminPortal.settings.kidsPlan.dataProviders.';
const prefixFields = 'adminPortal.settings.kidsPlan.fields.';

export const KIDS_PLAN_SETTINGS_GROUP_NAME = 'kids-data-provider';

export const dataProviderOptions = [
  {
    id: dataProvider.NANNY4ALL,
    name: t(prefixdataProviderOptions + dataProvider.NANNY4ALL)
  },
  {
    id: dataProvider.KINDPLANNER,
    name: t(prefixdataProviderOptions + dataProvider.KINDPLANNER)
  },
  {
    id: dataProvider.KONNECT_INTEGRATION,
    name: t(prefixdataProviderOptions + dataProvider.KONNECT_INTEGRATION)
  },
  {
    id: dataProvider.KONNECT,
    name: t(prefixdataProviderOptions + dataProvider.KONNECT)
  },
  {
    id: dataProvider.FLEX_KIDS,
    name: t(prefixdataProviderOptions + dataProvider.FLEX_KIDS)
  },
  {
    id: dataProvider.JAAMO,
    name: t(prefixdataProviderOptions + dataProvider.JAAMO)
  },
  {
    id: dataProvider.AYSIST,
    name: t(prefixdataProviderOptions + dataProvider.AYSIST)
  }
];

export const kidsPlanFields = [
  {
    type: 'autocomplete',
    name: 'kids_data_provider',
    labelKey: t(prefixFields + 'provider'),
    options: dataProviderOptions
  },
  {
    type: 'text',
    name: 'kids_data_provider_customerkey',
    labelKey: t(prefixFields + 'clientKey')
  },
  {
    type: 'text',
    name: 'kids_data_provider_username',
    labelKey: t(prefixFields + 'username')
  },
  {
    type: 'password',
    name: 'kids_data_provider_password',
    labelKey: t(prefixFields + 'password')
  },
  {
    type: 'text',
    name: 'kids_data_provider_url',
    labelKey: t(prefixFields + 'dataUrl')
  },
  {
    type: 'text',
    name: 'kids_data_provider_authUrl',
    labelKey: t(prefixFields + 'authenticationUrl')
  },
  {
    type: 'text',
    name: 'kids_data_provider_token',
    labelKey: t(prefixFields + 'authenticationToken')
  },
  {
    type: 'hidden',
    name: 'flexkids_api_implementation'
  }
];
